import React from "react";
import Button from "./Button";
export default function ProgramCard({
  imageSrc,
  imageAlt,
  title,
  description,
  btnOneText,
  btnOneLink,
  btnTwoText,
  btnTwoLink,
}) {
  return (
    <div className="py-5 flex flex-col md:flex-row md:gap-16 laptop:gap-20">
      <div className="w-full  h-[189px] laptopSm:h-[264px]  laptopSm:flex-1 laptopSm:items-stretch mb-6 md:mb-0 ">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="w-full h-full object-cover object-center rounded-2xl"
        />
      </div>

      <div className="w-full md:w-[55%] h-auto flex flex-col gap-3 md:gap-5 md:relative">
        <h1 className="capitalize font-montserrat font-semibold text-xl md:text-4xl leading-4 tracking-[0.04em] text-text-dark">
          {title}
        </h1>
        <p className="font-notoSans font-light text-xs md:text-sm leading-6 tracking-[0.06em] text-black">
          {description}
        </p>
        <div className="flex gap-2 md:gap-4 mt-2 md:-mt-2 justify-end">
          <Button
            text={btnOneText}
            type={"outline"}
            arrow={false}
            navigateTo={btnOneLink}
          />
          <Button
            text={btnTwoText}
            type={"none"}
            arrow={false}
            navigateTo={btnTwoLink}
          />
        </div>
      </div>
    </div>
  );
}
